import React from "react";

import logo from "../../assets/images/logo.svg";
import { VAMA_HOME_URL } from "../../utils/links";
import { getDownloadTarget } from "../../utils/platform";

function PageHeader() {
  const download = getDownloadTarget();

  return (
    <header className="vp-header">
      <div className="vp-header-inner">
        <a className="vp-brand" href={VAMA_HOME_URL}>
          <img src={logo} alt="" width="26" height="24" />
          <span>Vama</span>
        </a>
        <a className="vp-header-btn" href={download.href}>
          {download.label}
        </a>
      </div>
    </header>
  );
}

export default PageHeader;
